export enum Events {
  MemberAdded = 'member_added',
  MemberRemoved = 'member_removed'
}
